import Vue from "vue";
import VueRouter from "vue-router";
import Start from "../views/Start.vue";
import Betrieb from "../views/Betrieb.vue";
import Shop from "../views/Shop.vue";
import ShippingInfo from "../views/ShippingInfo.vue";
import Checkout from "../views/Checkout.vue";
import Cart from "../views/Cart.vue";
import CookieInfo from "../views/CookieInfo";
import OrderConfirmation from "../views/OrderConfirmation";
import OrderError from "../views/OrderError";
import Product from "../components/shop/Product.vue";
import Impressum from "../views/Impressum.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Start",
    component: Start
  },
  {
    path: "/betrieb",
    name: "Betrieb",
    component: Betrieb
  },
  {
    path: "/shop",
    name: "Shop",
    component: Shop
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart
  },
  {
    path: "/shippingInfo",
    name: "ShippingInfo",
    component: ShippingInfo
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout
  },
  {
    path: "/shop/product/:productTitle",
    name: "Product",
    component: Product,
    props: true
  },
  {
    path: "/cookieinfo",
    name: "CookieInfo",
    component: CookieInfo
  },
  {
    path: "/orderConfirmation",
    name: "OrderConfirmation",
    component: OrderConfirmation
  },
  {
    path: "/orderError",
    name: "OrderError",
    component: OrderError
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: Impressum
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
